module.exports = __webpack_public_path__ + "img/TransmitTaskCreate.33d0afa0.png";